import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session'; //This use sessionStorage

import thunk from 'redux-thunk';
import authenticatioauthennSlice from './authentication/authenticationSlice';
import EmployeeEventsSlice from './EmployeeEvents/EmployeeEventsSlice';
import EmployeeProviderSlice from './EmployeeProviders/EmployeeProviderSlice';
import EmployeeContractorsSlice from './EmployeeContractors/EmployeeContractorsSlice';
import EmployeeZonesSlice from './EmployeeZones/EmployeeZoneSlice';
import DevicesSlice from './Devices/DevicesSlice';
import CardsSlice from './Cards/CardsSlice';
import CommonsSlice from './Commons/CommonsSlice';
import SearchSlice from './Search/SearchSlice';
import FilesSlice from './Files/FilesSlice';
import CompanyWorkShiftSlice from './CompanyWorkShift/CompanyWorkShiftSlice';
import LogSlice from './Logs/LogSlice';
import providersSlice from './Providers/providerSlice';
import ContractorSlice from './Contractor/ContractorSlice';
import UserDocPanelSlice from './UserDocPanel/UserDocPanelSlice';
import CompanyEmployeesSlice from './CompanyEmployees/CompanyEmployeesSlice';
import EmployeeRolesSlice from './EmployeeRoles/EmployeeRolesSlice';
import CompanyVehiclesSlice from './CompanyVehicles/CompanyVehiclesSlice';
import UpdateCompanySlice from './UpdateCompany/UpdateCompanySlice';
import employeePayrollSlice from './EmployeePayRoll/EmployeePayRollSlice';
import BackUpSlice from './CompanyBackup/backUpSlice';
import employeeOnBoardingSlice from './EmployeeOnBoarding/EmployeeOnBoardingSlice';
import headersSlice from './headers/headersSlice';
import documentPanelSlice from './DocumentPanel/DocumentPanelSlice';
import departmentSectionSlice from './Department/DepartmentSlice';
import EmployeeSlice from './Employee/EmployeeSlice';
import VehicleSlice from './Vehicle/VehicleSlice';
import sharedSlice from './ShareSlice/shareSlice';
import RestrictionSlice from './restrictions/RestrictionSlice';
import VisitorSlice from './Visitor/VisitorSlice';
import HidSlice from './HID/HidSlice';
import GraphsSlice from './Graphs/GraphsSlice';
import employeeFoodieSlice from './Foodie/FoodieSlice';
import ReportSlice from './Reports/ReportSlice';
import SystemConfigSlice from "./SystemConfig/SystemConfigSlice";
import DistributionCenterSlice from "./DistributionCenter/DistributionCenterSlice";
import ServiceTypeSlice from "./ServiceType/ServiceTypeSlice";
import ApprovalSlice from "./Approval/ApprovalSlice"
import BuildingSlice from "./Building/BuildingSlice"
import IngredientSlice from './FoodieIngredient/IngredientSlice';
import MenuSlice from './FoodieMenu/MenuSlice';
import VisitorTypesSlice from './VisitorTypes/VisitorTypesSlice';
import InvitationSlice from './Invitation/InvitationSlice';
import MealTimeSlice from './FoodieMealTime/MealTimeSlice';
import FoodieShiftSlice from './FoodieShift/FoodieShiftSlice';
import FoodieExtraMealSlice from './FoodieExtraMeal/FoodieExtraMealSlice';
import FoodieOrdersSlice from './FoodieOrders/FoodieOrdersSlice'
import DishSlice from './FoodieDishes/DishesSlice';
import ApprovalTrackerSlice from "./ApprovalTracker/ApprovalTrackerSlice";
import UserFileSlice from './UserFile/UserFileSlice';
import AddressSlice from './Address/AdressSlice';
import RequestAccessSlice from './RequestAccess/RequestAccessSlice';
import FineTypesSlice from './FineTypes/FineTypesSlice'
import CafeteriaSlice from './FoodieCafeteria/CafeteriaSlice';
import FineManageSlice from './FineManage/FineManageSlice';
import TrafficSlice from './Traffic/TrafficSlice';
import FineGeofenceSlice from "./FineGeofence/FineGeofenceSlice";
import TrafficFinesSlice from './TrafficFines/TrafficFinesSlice';
import equipmentSlice from './EquipmentAndMaterial/EquipmentSlice';
import AttendanceShiftSlice from './AttendanceShift/AttendanceShiftSlice'
import UserPreferencesSlice from "./UserPreferences/UserPreferencesSlice";
import UserSpecialPermissionSlice from "./UserSpecialPermission/UserSpecialPermissionSlice";
import AttendanceAdjustmentSlice from "./AttendanceAdjustment/AttendanceAdjustmentSlice";
import AttendanceAdjustmentPersistSlice from "./AttendanceAdjustment/AttendanceAdjustmentPersistSlice";
import AttendancePersistSlice from "./EmployeePayRoll/AttendancePersistSlice";
import PayrollPolicySlice from "./PayrollPolicy/PayrollPolicySlice";
import AttendanceGeofenceSlice from "./AttendanceGeofence/AttendanceGeofenceSlice";



const reducers = combineReducers({
    UpdateCompanySlice,
    authenticatioauthennSlice,
    EmployeeContractorsSlice,
    EmployeeEventsSlice,
    EmployeeProviderSlice,
    EmployeeZonesSlice,
    DevicesSlice,
    HidSlice,
    CardsSlice,
    CommonsSlice,
    SearchSlice,
    FilesSlice,
    CompanyWorkShiftSlice,    LogSlice,
    GraphsSlice,
    providersSlice,
    ContractorSlice,
    UserDocPanelSlice,
    CompanyEmployeesSlice,
    EmployeeRolesSlice,
    CompanyVehiclesSlice,
    employeePayrollSlice,
    BackUpSlice,
    employeeOnBoardingSlice,
    headersSlice,
    documentPanelSlice,
    departmentSectionSlice,
    EmployeeSlice,
    sharedSlice,
    VehicleSlice,
    VisitorSlice,
    RestrictionSlice,
    ReportSlice,
    SystemConfigSlice,
    ServiceTypeSlice,
    DistributionCenterSlice,
    VisitorTypesSlice,
    employeeFoodieSlice,
    ApprovalSlice,
    BuildingSlice,
    IngredientSlice,
    InvitationSlice,
    MenuSlice,
    MealTimeSlice,
    FoodieShiftSlice,
    FoodieOrdersSlice,
    DishSlice,
    ApprovalTrackerSlice,
    UserFileSlice,
    FoodieExtraMealSlice,
    AddressSlice,
    RequestAccessSlice,
    FineTypesSlice,
    CafeteriaSlice,
    FineManageSlice,
    TrafficSlice,
    FineGeofenceSlice,
    TrafficFinesSlice,
    equipmentSlice,
    AttendanceShiftSlice,
    UserPreferencesSlice,
    UserSpecialPermissionSlice,
    AttendanceAdjustmentSlice,
    AttendanceAdjustmentPersistSlice,
    AttendancePersistSlice,
    PayrollPolicySlice,
    AttendanceGeofenceSlice
});

const persistConfig = {
    key: 'root',
    storage,
    whitelist: [
        'authenticatioauthennSlice',
        'AttendanceAdjustmentPersistSlice',
        'AttendancePersistSlice'
    ],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: [thunk],
});

export default store;
